unit UHolidayModel;

interface

uses
  UAbwModel, Js, UEssentialHelper;

type
  THolidayModel = class
  private
    FBegruendung: string;
    FBis: TDateTime;
    FVon: TDateTime;
    FStatusText: string;
    FAbw: TAbwModel;
    FId: Integer;
    FGrund: string;
    FStatus: Integer;
    FGenehmigt: Boolean;
    FGenehmigtVon: string;
    FAngelegt: TDateTime;
    FOnPropertyChanged: TCallback;
    FErgebnis: string;
    procedure Response(Sender: TObject; AResponse: string);
    procedure ClearValues;
    procedure PropertyChanged;
    procedure SetValues(Json: string); overload;
    procedure SetValues(Obj: TJsObject); overload;
    procedure SetAbw(const Value: TAbwModel);
    procedure SetBegruendung(const Value: string);
    procedure SetBis(const Value: TDateTime);
    procedure SetGenehmigt(const Value: Boolean);
    procedure SetGenehmigtVon(const Value: string);
    procedure SetGrund(const Value: string);
    procedure SetId(const Value: Integer);
    procedure SetStatus(const Value: Integer);
    procedure SetStatusText(const Value: string);
    procedure SetVon(const Value: TDateTime);
    procedure SetAngelegt(const Value: TDateTime);
    procedure SetOnPropertyChanged(const Value: TCallback);
    procedure SetErgebnis(const Value: string);
  public
    constructor Create; overload;
    constructor Create(Json: string); overload;
    procedure GetResturlaub(Url: string; PersonalNr: string;
      ZaResturlaubId: Integer; Jahr: Integer);
    procedure GetUrlaubsanspruchLfdJahr(Url: string; PersonalNr: string;
      ZaResturlaubId: Integer; Jahr: Integer);
    procedure GetUrlaubGenommen(Url: string; PersonalNr: string;
      ZaResturlaubId: Integer; Jahr: Integer);
    procedure GetUrlaubAusbezahlt(Url: string; PersonalNr: string;
      ZaResturlaubId: Integer; Jahr: Integer);
    procedure GetUrlaubGeplant(Url: string; PersonalNr: string;
      zaUrlaubId: Integer);
    procedure GetUrlaubPlanbar(Url: string; PersonalNr: string;
      ZaResturlaubId: Integer; zaUrlaubId: Integer; Jahr: Integer);
    procedure CheckAppForLeave(Url: string; PersonalNr: string);
    procedure GetErrorMessage(Url: string; Nr: Integer);
    procedure InsertAppForLeave(Url: string; PersonalNr: string);
    procedure CancelAppForLeave(Url: string);
    property Id: Integer read FId write SetId;
    property Von: TDateTime read FVon write SetVon;
    property Bis: TDateTime read FBis write SetBis;
    property Grund: string read FGrund write SetGrund;
    property Genehmigt: Boolean read FGenehmigt write SetGenehmigt;
    property GenehmigtVon: string read FGenehmigtVon write SetGenehmigtVon;
    property Begruendung: string read FBegruendung write SetBegruendung;
    property Status: Integer read FStatus write SetStatus;
    property StatusText: string read FStatusText write SetStatusText;
    property Abw: TAbwModel read FAbw write SetAbw;
    property Angelegt: TDateTime read FAngelegt write SetAngelegt;
    property OnPropertyChanged: TCallback read FOnPropertyChanged
      write SetOnPropertyChanged;
    property Ergebnis: string read FErgebnis write SetErgebnis;
  end;

implementation

uses
  System.SysUtils, WebLib.REST, WebLib.Json;

{ THolidayModel }

procedure THolidayModel.Response(Sender: TObject; AResponse: string);
var
  jso: TJsObject;
  s: string;
begin
  jso := TJsJson.parseObject(AResponse);
  if jso['value'] <> nil then
  begin
    s := string(jso['value']);
    jso := TJsJson.parseObject(s);
    if jso['Result'] <> nil then
      Self.Ergebnis := string(jso['Result']);
  end;
  Self.PropertyChanged;
end;

procedure THolidayModel.CancelAppForLeave(Url: string);
var
  Obj: TJsonObject;
  helper: string;
  client: TRestClient;
begin
  Obj := TJsonObject.Create;
  Obj.AddPair('Id', IntToStr(Self.Id));
  Obj.AddPair('Reason', Self.Begruendung);
  helper := Obj.ToString;
  Obj := TJsonObject.Create;
  Obj.AddPair('value', helper);
  client := TRestClient.Create(nil);
  client.OnResponse := Response;
  client.HttpsPost(Url + '/HolidayService/CancelAppForLeave',
    'application/json', Obj.ToString);
  client.Free;
end;

procedure THolidayModel.CheckAppForLeave(Url: string; PersonalNr: string);
var
  Obj: TJsonObject;
  helper: string;
  client: TRestClient;
  procedure ResponseIntern(Sender: TObject; AResponse: string);
  var
    jso: TJsObject;
    s: string;
  begin
    jso := TJsJson.parseObject(AResponse);
    if jso['value'] <> nil then
    begin
      s := string(jso['value']);
      jso := TJsJson.parseObject(s);
      if jso['Result'] <> nil then
        Self.Ergebnis := string(jso['Result']);
      if jso['Von'] <> nil then
        Self.Von := StrToDateTime(string(jso['Von']));
      if jso['Bis'] <> nil then
        Self.Bis := StrToDateTime(string(jso['Bis']));
    end;
    Self.PropertyChanged;
  end;

begin
  Obj := TJsonObject.Create;
  Obj.AddPair('AbwId', IntToStr(Self.Abw.Id));
  Obj.AddPair('PersonalNr', PersonalNr);
  Obj.AddPair('Von', DateTimeToStr(Self.Von));
  Obj.AddPair('Bis', DateTimeToStr(Self.Bis));
  helper := Obj.ToString;
  Obj := TJsonObject.Create;
  Obj.AddPair('value', helper);
  client := TRestClient.Create(nil);
  client.OnResponse := ResponseIntern;
  client.HttpsPost(Url + '/HolidayService/CheckAppForLeave', 'application/json',
    Obj.ToString);
  client.Free;
end;

procedure THolidayModel.ClearValues;
begin
  Self.Id := 0;
  Self.Von := 0;
  Self.Bis := 0;
  Self.Grund := '';
  Self.Genehmigt := false;
  Self.GenehmigtVon := '';
  Self.Begruendung := '';
  Self.Status := -1;
  Self.StatusText := '';
  if Self.Abw = nil then
    Self.Abw := TAbwModel.Create
  else
    Self.Abw.ClearValues;
  Self.Angelegt := 0;
  Self.OnPropertyChanged := nil;
  Self.Ergebnis := '';
end;

constructor THolidayModel.Create;
begin
  Self.ClearValues;
end;

constructor THolidayModel.Create(Json: string);
begin
  Self.SetValues(Json);
end;

procedure THolidayModel.GetErrorMessage(Url: string; Nr: Integer);
var
  Obj: TJsonObject;
  helper: string;
  client: TRestClient;
begin
  Obj := TJsonObject.Create;
  Obj.AddPair('Nr', IntToStr(Nr));
  helper := Obj.ToString;
  Obj := TJsonObject.Create;
  Obj.AddPair('value', helper);
  client := TRestClient.Create(nil);
  client.OnResponse := Response;
  client.HttpsPost(Url + '/HolidayService/GetErrorMessage', 'application/json',
    Obj.ToString);
  client.Free;
  Obj.Free;
end;

procedure THolidayModel.GetResturlaub(Url, PersonalNr: string;
  ZaResturlaubId, Jahr: Integer);
var
  Obj: TJsonObject;
  helper: string;
  client: TRestClient;
begin
  Obj := TJsonObject.Create;
  Obj.AddPair('PersonalNr', PersonalNr);
  Obj.AddPair('ZaResturlaubId', IntToStr(ZaResturlaubId));
  Obj.AddPair('Jahr', IntToStr(Jahr));
  helper := Obj.ToString;
  Obj := TJsonObject.Create;
  Obj.AddPair('value', helper);
  client := TRestClient.Create(nil);
  client.OnResponse := Response;
  client.HttpsPost(Url + '/HolidayService/GetResturlaub', 'application/json',
    Obj.ToString);
  client.Free;
  Obj.Free;
end;

procedure THolidayModel.GetUrlaubAusbezahlt(Url, PersonalNr: string;
  ZaResturlaubId, Jahr: Integer);
var
  Obj: TJsonObject;
  helper: string;
  client: TRestClient;
begin
  Obj := TJsonObject.Create;
  Obj.AddPair('PersonalNr', PersonalNr);
  Obj.AddPair('ZaResturlaubId', IntToStr(ZaResturlaubId));
  Obj.AddPair('Jahr', IntToStr(Jahr));
  helper := Obj.ToString;
  Obj := TJsonObject.Create;
  Obj.AddPair('value', helper);
  client := TRestClient.Create(nil);
  client.OnResponse := Response;
  client.HttpsPost(Url + '/HolidayService/GetUrlaubAusbezahlt',
    'application/json', Obj.ToString);
  client.Free;
  Obj.Free;
end;

procedure THolidayModel.GetUrlaubGenommen(Url, PersonalNr: string;
  ZaResturlaubId, Jahr: Integer);
var
  Obj: TJsonObject;
  helper: string;
  client: TRestClient;
begin
  Obj := TJsonObject.Create;
  Obj.AddPair('PersonalNr', PersonalNr);
  Obj.AddPair('ZaResturlaubId', IntToStr(ZaResturlaubId));
  Obj.AddPair('Jahr', IntToStr(Jahr));
  helper := Obj.ToString;
  Obj := TJsonObject.Create;
  Obj.AddPair('value', helper);
  client := TRestClient.Create(nil);
  client.OnResponse := Response;
  client.HttpsPost(Url + '/HolidayService/GetUrlaubGenommen',
    'application/json', Obj.ToString);
  client.Free;
  Obj.Free;
end;

procedure THolidayModel.GetUrlaubGeplant(Url, PersonalNr: string;
  zaUrlaubId: Integer);
var
  Obj: TJsonObject;
  helper: string;
  client: TRestClient;
begin
  Obj := TJsonObject.Create;
  Obj.AddPair('PersonalNr', PersonalNr);
  Obj.AddPair('ZaUrlaubId', IntToStr(zaUrlaubId));
  helper := Obj.ToString;
  Obj := TJsonObject.Create;
  Obj.AddPair('value', helper);
  client := TRestClient.Create(nil);
  client.OnResponse := Response;
  client.HttpsPost(Url + '/HolidayService/GetUrlaubGeplant', 'application/json',
    Obj.ToString);
  client.Free;
  Obj.Free;
end;

procedure THolidayModel.GetUrlaubPlanbar(Url, PersonalNr: string;
  ZaResturlaubId, zaUrlaubId, Jahr: Integer);
var
  Obj: TJsonObject;
  helper: string;
  client: TRestClient;
begin
  Obj := TJsonObject.Create;
  Obj.AddPair('PersonalNr', PersonalNr);
  Obj.AddPair('ZaResturlaubId', IntToStr(ZaResturlaubId));
  Obj.AddPair('ZaUrlaubId', IntToStr(zaUrlaubId));
  Obj.AddPair('Jahr', IntToStr(Jahr));
  helper := Obj.ToString;
  Obj := TJsonObject.Create;
  Obj.AddPair('value', helper);
  client := TRestClient.Create(nil);
  client.OnResponse := Response;
  client.HttpsPost(Url + '/HolidayService/GetUrlaubPlanbar', 'application/json',
    Obj.ToString);
  client.Free;
  Obj.Free;
end;

procedure THolidayModel.GetUrlaubsanspruchLfdJahr(Url, PersonalNr: string;
  ZaResturlaubId, Jahr: Integer);
var
  Obj: TJsonObject;
  helper: string;
  client: TRestClient;
begin
  Obj := TJsonObject.Create;
  Obj.AddPair('PersonalNr', PersonalNr);
  Obj.AddPair('ZaResturlaubId', IntToStr(ZaResturlaubId));
  Obj.AddPair('Jahr', IntToStr(Jahr));
  helper := Obj.ToString;
  Obj := TJsonObject.Create;
  Obj.AddPair('value', helper);
  client := TRestClient.Create(nil);
  client.OnResponse := Response;
  client.HttpsPost(Url + '/HolidayService/GetUrlaubsanspruchLfdJahr',
    'application/json', Obj.ToString);
  client.Free;
  Obj.Free;
end;

procedure THolidayModel.InsertAppForLeave(Url, PersonalNr: string);
var
  Obj: TJsonObject;
  helper: string;
  client: TRestClient;
begin
  Obj := TJsonObject.Create;
  Obj.AddPair('PersonalNr', PersonalNr);
  Obj.AddPair('AbwId', IntToStr(Self.Abw.Id));
  Obj.AddPair('Von', DateTimeToStr(Von));
  Obj.AddPair('Bis', DateTimeToStr(Bis));
  Obj.AddPair('Grund', Self.Grund);
  helper := Obj.ToString;
  Obj := TJsonObject.Create;
  Obj.AddPair('value', helper);
  client := TRestClient.Create(nil);
  client.OnResponse := Response;
  client.HttpsPost(Url + '/HolidayService/InsertAppForLeave',
    'application/json', Obj.ToString);
  client.Free;
end;

procedure THolidayModel.PropertyChanged;
begin
  if Assigned(Self.OnPropertyChanged) then
    Self.OnPropertyChanged(Self);
end;

procedure THolidayModel.SetAbw(const Value: TAbwModel);
begin
  FAbw := Value;
end;

procedure THolidayModel.SetAngelegt(const Value: TDateTime);
begin
  FAngelegt := Value;
end;

procedure THolidayModel.SetBegruendung(const Value: string);
begin
  FBegruendung := Value;
end;

procedure THolidayModel.SetBis(const Value: TDateTime);
begin
  FBis := Value;
end;

procedure THolidayModel.SetErgebnis(const Value: string);
begin
  FErgebnis := Value;
end;

procedure THolidayModel.SetGenehmigt(const Value: Boolean);
begin
  FGenehmigt := Value;
end;

procedure THolidayModel.SetGenehmigtVon(const Value: string);
begin
  FGenehmigtVon := Value;
end;

procedure THolidayModel.SetGrund(const Value: string);
begin
  FGrund := Value;
end;

procedure THolidayModel.SetId(const Value: Integer);
begin
  FId := Value;
end;

procedure THolidayModel.SetOnPropertyChanged(const Value: TCallback);
begin
  FOnPropertyChanged := Value;
end;

procedure THolidayModel.SetStatus(const Value: Integer);
begin
  FStatus := Value;
end;

procedure THolidayModel.SetStatusText(const Value: string);
begin
  FStatusText := Value;
end;

procedure THolidayModel.SetValues(Obj: TJsObject);
begin
  Self.ClearValues;
  if Obj['Id'] <> nil then
    Self.Id := StrToInt(string(Obj['Id']));
  if Obj['Von'] <> nil then
    Self.Von := StrToDateTime(string(Obj['Von']));
  if Obj['Bis'] <> nil then
    Self.Bis := StrToDateTime(string(Obj['Bis']));
  if Obj['Grund'] <> nil then
    Self.Grund := string(Obj['Grund']);
  if Obj['Genehmigt'] <> nil then
    Self.Genehmigt := StrToBoolean(string(Obj['Genehmigt']));
  if Obj['GenehmigtVon'] <> nil then
    Self.GenehmigtVon := string(Obj['GenehmigtVon']);
  if Obj['Begruendung'] <> nil then
    Self.Begruendung := string(Obj['Begruendung']);
  if Obj['Status'] <> nil then
    Self.Status := StrToInt(string(Obj['Status']));
  if Obj['StatusText'] <> nil then
    Self.StatusText := string(Obj['StatusText']);
  if Obj['Abw'] <> nil then
    Self.Abw.SetValues(string(Obj['Abw']));
  if Obj['Angelegt'] <> nil then
    Self.Angelegt := StrToDateTime(string(Obj['Angelegt']));
end;

procedure THolidayModel.SetValues(Json: string);
var
  Obj: TJsObject;
begin
  Obj := TJsJson.parseObject(Json);
  Self.SetValues(Obj);
end;

procedure THolidayModel.SetVon(const Value: TDateTime);
begin
  FVon := Value;
end;

end.
